module.exports = __webpack_public_path__ + "images/fbdb001f2e18beb3b8b466f13940a568.png";